var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-image__placeholder"},[_c('el-empty',{attrs:{"description":"没有账号分配"}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.download}},[_vm._v("客户端下载")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }